import React from 'react'

import { Link } from 'react-router-dom'

const CloudComputingCard = () => {
  return (
    <div className="card w-25 h-auto">
        <div className="card-body">
          <h5 className="card-title">Cloud Computing</h5>
          <p className="card-text">
          AWS Certified Cloud Practitioner.</p>
          <p>Working on my AWS Certified AI Practitioner.
          </p>

          <h6 className='card-title'>You can now Chat with me!!!</h6>
          <p className="card-text">
          Chat with my personalize Chatbot.
          </p>
          <Link href="#" className="btn btn-dark" to="/cloud-computing">  
            Go to Cloud Computing
          </Link>
        </div>
      </div>
  )
}

export default CloudComputingCard